import { DataDecompressor } from "../../../utilities/descomprimirRespuestas";
import { desEncriptar } from "../../../utilities/encriptacion";
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const  getServices = async(setState,params) => {
    
    await api.post(`${apiUrl}/monitor/programacion/getServicios`,params).then((res) => {
      const data =  DataDecompressor.decompressData(res.data);
        setState(data) 

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const  getInfoOperador = async(setState,id_operador,setLoading) => {
     const params = {
        id_operador:id_operador
     }
    await api.post(`${apiUrl}/monitor/programacion/getInformacionChofer`,params).then((res) => {
      
        setState(res.data) 
         setLoading(false);

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const  getInformacionUnidad = async(setState,id_unidad,setLoading) => {
     const params = {
        id_unidad:id_unidad
     }
    await api.post(`${apiUrl}/monitor/programacion/getInformacionUnidad`,params).then((res) => {
      
        setState(res.data) 
         setLoading(false);

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const  getUnidadesDisponiblesAPI = async(setState,fecha,horaInicio,horaFin,tipoUnidad) => {
     const params = {
        fecha:fecha,
        hora_inicio:horaInicio,
        hora_fin:horaFin,
        tipo_unidad:tipoUnidad
     }
    await api.post(`${apiUrl}/monitor/tablero/getUnidadesDisponibles`,params).then((res) => {
            setState(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getRealTimeTracking = async(setState, params) => {
    try {
        await api.post(`${apiUrl}/monitor/programacion/get-trazo-maestro-servicios`, params).then((res) => {
            setState(res.data);
        });
    } catch (error) {
        console.log("error", error);
    }
};
